import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { InvoiceForm } from '@/components/invoice/InvoiceForm';

export default function CreateInvoice() {
  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-2">
        <Link to="/invoices">
          <Button variant="ghost" size="icon">
            <ArrowLeft className="h-4 w-4" />
          </Button>
        </Link>
        <h1 className="text-2xl font-bold tracking-tight">Create Invoice</h1>
      </div>

      <InvoiceForm />
    </div>
  );
}